<script setup>
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>
<template>
  <div class="section-container">
    <div class="relative z-10 flex flex-col justify-center items-start w-full text-left h-full">
      <!-- Title -->
      <h2 class="text-4xl md:text-5xl text-center mb-16">{{ t("Aanmelden bij Zorgblik") }}</h2>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-12 text-center md:text-left">
        <!-- Column 1 -->
        <div>
          <div class="h-1 w-full bg-green-200 mb-4"></div>
          <h3 class="text-lg md:text-xl font-bold mb-2">{{ t("Registratie") }}</h3>
          <p
            class="text-gray-700"
          >{{ t("Doorloop het eenvoudige online registratieproces voor uw zorgorganisatie en krijg direct toegang tot ons platform.") }}</p>
        </div>
        <!-- Column 2 -->
        <div>
          <div class="h-1 w-full bg-green-200 mb-4"></div>
          <h3 class="text-lg md:text-xl font-bold mb-2">{{ t("Dashboard") }}</h3>
          <p
            class="text-gray-700"
          >{{ t("Selecteer in uw persoonlijke omgeving de gewenste zorgdisciplines en stel uw specifieke behoeften in.") }}</p>
        </div>
        <!-- Column 3 -->
        <div>
          <div class="h-1 w-full bg-green-200 mb-4"></div>
          <h3 class="text-lg md:text-xl font-bold mb-2">{{ t("Veiligheid") }}</h3>
          <p
            class="text-gray-700"
          >{{ t("Rust verzekerd - ons platform voldoet volledig aan NEN-7510 en AVG-richtlijnen voor optimale gegevensbescherming.") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
